import { Currency } from '../../../global/models';

export default function getCurrencySymbol(currency: Currency, locale: string): string {
    switch (currency) {
        case Currency.USD:
            return '$USD';

        case Currency.CAD:
            return '$CAD';

        case Currency.EUR:
            return '€EUR';

        case Currency.HKD: {
            if (locale.startsWith('zh')) {
                return '港元'; // NOTE: that's traditional (i.e. zh-Hant).  Simplified (zh-Hans) is 港币
            }

            return '$HKD';
        }

        case Currency.PHP:
            return '₱PHP';

        default:
            throw Error(`Unsupported currency symbol: ${currency}`);
    }
}
